import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
export var FaireDirectSectionErrorFallback = function() {
    return /*#__PURE__*/ _jsxs(Column, {
        align: "center",
        justify: "center",
        style: {
            padding: "48px"
        },
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                align: "center",
                variant: "displaySSerifRegular",
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "KL+NDZ",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Oops, something went wrong!"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "2x"
            }),
            /*#__PURE__*/ _jsx(Typography, {
                variant: "subheadingSansRegular",
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "NcXZlX",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Please refresh your page and try again."
                        }
                    ]
                })
            })
        ]
    });
};
